import React from 'react'
import img1 from '../../Assets/dept/1.png'
import img2 from '../../Assets/dept/2.png'
import img3 from '../../Assets/dept/3.png'
import img4 from '../../Assets/dept/4.png'
import img5 from '../../Assets/dept/5.png'
import img6 from '../../Assets/dept/6.png'
import img7 from '../../Assets/dept/7.png'
import img8 from '../../Assets/dept/8.png'
import img9 from '../../Assets/dept/9.png'
import img10 from '../../Assets/dept/10.jpg'
import img11 from '../../Assets/dept/11.png'
import img12 from '../../Assets/dept/12.png'
import img13 from '../../Assets/dept/13.png'
import img14 from '../../Assets/dept/14.png'
import img15 from '../../Assets/dept/15.png'


const ImageGallery = () => {
  return (
    <div className="containergallery">

	<h1 className="headinggall">Placement - 2024</h1>

	<div className="gallery">

		<div className="gallery-item">
			<img className="gallery-image" src={img2} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img7} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img1} alt="Placement - 2024"/>
		</div>

		

		<div className="gallery-item">
			<img className="gallery-image" src={img3} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img4} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img5} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img6} alt="Placement - 2024"/>
		</div>

		

		<div className="gallery-item">
			<img className="gallery-image" src={img8} alt="Placement - 2024"/>
		</div>

		<div className="gallery-item">
			<img className="gallery-image" src={img9} alt="Placement - 2024"/>
		</div>

	</div>
	
	<br />
	<br /><br />
	<h1>---------------------------------------------------------------------------</h1>
	<br />
	<h1>Summer Intership - 2024</h1>

	<br />
	<br />
	<div className="gallery" >

		<div>
		</div>
		<div className="gallery-item">
		<img className="gallery-image" src={img10} alt="Summer Intership - 2024"/>
	</div>
		<div>
		</div>
	</div>
	<br />

	<h1>---------------------------------------------------------------------------</h1>

	<br />
	<h1>Placement - 2023</h1>

	<br />
	<br />
	<div className="gallery" >

		
		<div className="gallery-item">
			<img className="gallery-image" src={img11} alt="Placement - 2023"/>
		</div>
		<div className="gallery-item">
			<img className="gallery-image" src={img12} alt="Placement - 2023"/>
		</div>
		<div className="gallery-item">
			<img className="gallery-image" src={img13} alt="Placement - 2023"/>
		</div>
		
			<div className="gallery-item">
				<img className="gallery-image" src={img14} alt="Placement - 2023"/>
			</div>
		
			<div className="gallery-item">
				<img className="gallery-image" src={img15} alt="Placement - 2023"/>
			</div>
		
		




	</div>
	<br />
	


</div>
  )
}

export default ImageGallery